import { render, staticRenderFns } from "./CartTable.vue?vue&type=template&id=53d4d74c&scoped=true&"
import script from "./CartTable.vue?vue&type=script&lang=js&"
export * from "./CartTable.vue?vue&type=script&lang=js&"
import style0 from "./CartTable.vue?vue&type=style&index=0&id=53d4d74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d4d74c",
  null
  
)

export default component.exports